import { getEnvironmentId } from "./../store/environment/actions";
import { INotification } from "@/interfaces/i-notification";
import { dispatch } from "./dispatch";
import { EventBus } from "./event-bus";

import fetch from "@mv/flow-shared-utils/functions/fetch";
import { handleErrors } from "@/utils/handle-errors";

import { deployFlowGroups, deployFlowUsers, loadFlowGroups, loadFlowUsers } from "@/store/deploy/actions";
import { loadQuizzesByEnvironment } from "@/store/quiz/actions";

const dataProvider = {
  loadProducts() {
    return fetch("core/api/system/integration")
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  loadScreens(product: string) {
    return fetch(`core/api/external/screen/origin/${product}`)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadSimpleFormDetail(formId: number) {
    return fetch(`core/api/forms/${formId}`)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadUsers() {
    return dispatch(loadFlowUsers)();
  },

  loadGroups() {
    return dispatch(loadFlowGroups)();
  },

  syncUsers() {
    return dispatch(deployFlowUsers)();
  },

  syncGroups() {
    return dispatch(deployFlowGroups)();
  },

  loadCatalogUrl() {
    return fetch("core/api/configuration/environment/mvapi")
      .then((res) => {
        if (res.status === 200) {
          return res.text();
        } else {
          throw res.json();
        }
      })
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadCatalogApis() {
    return fetch(`core/api/external-api/mount-controllers`)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadSoulFlexScreens(pageNumber = 1, search?: string) {
    const pageSize = search === undefined ? 20 : 9999;
    let targetUrl = `core/api/data/flow-api/module/paginated?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (search) {
      targetUrl = targetUrl + `&search=${search}`;
    }
    return fetch(targetUrl)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  loadQuizzesByEnvironment() {
    return dispatch(loadQuizzesByEnvironment)();
  },

  async testDatabaseConnection(database: string, url: string, user: string, password: string) {
    const envId = await dispatch(getEnvironmentId)();
    return fetch(`flow/api/external-database/test?database=${database}&url=${url}&user=${user}&password=${password}&environmentId=${envId}`)
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  loadExposedApiFields(documentId: number) {
    return fetch(`core/api/external/screen/editor/expose-api-fields/document/${documentId}`)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },

  notify(not: INotification) {
    EventBus.$emit("emmit-notification", not);
  },
};

export default dataProvider;
